import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import NavMenu from './NavMenu';
import './Layout.css';
export default props => (
  <Container fluid>
    <Row>
      <Col lg="3">
        <NavMenu />
      </Col>
      <Col lg="9">
        <Container fluid="lg">
          {props.children}
        </Container>
      </Col>
    </Row>
  </Container>
);
